import { devices } from '@src/styles/theme';
import Link from 'next/link';
import React from 'react';
import styled from 'styled-components';

const EndDonationPage = () => {
  return (
    <Container>
      <Wrap>
        <Content>종료된 사연입니다.</Content>
        <Description>찾으려는 사연이 종료되었습니다.</Description>
        <Home>
          <Link href={'/'}>피플 홈 가기</Link>
        </Home>
      </Wrap>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const Wrap = styled.section`
  text-align: center;
`;

const Content = styled.strong`
  display: inline-block;
  margin: 24px 0px 16px 0px;
  font-weight: 600;
  font-size: 30px;
  @media ${devices.tablet} {
    font-size: 16px;
  }
`;

const Description = styled.p`
  color: ${({ theme }) => theme.commonColor.gray005};
  font-weight: 400;
  font-size: 18px;
  text-align: center;
  letter-spacing: -0.6px;
  line-height: 32px;
`;

const Home = styled.button`
  background-color: ${({ theme }) => theme.commonColor.pink001};
  border-radius: 5px;
  width: 100px;
  height: 50px;
  color: ${({ theme }) => theme.commonColor.pink004};
  cursor: pointer;
  margin-top: 18px;
`;

export default EndDonationPage;
